import type { ReactNode } from "react";

import { PUBLIC_SHELL_HIDE_HOME_SIDEBAR } from "@/lib/publicShell/launchSurfaceFlags";
import { UNIFIED_NAVBAR_CONTENT_OFFSET_CLASS } from "@/lib/layout/navbarChrome";
import { cn } from "@/lib/utils";

type AramlasHomeShellLoadingFrameProps = {
  children: ReactNode;
  className?: string;
};

/** Mirrors ArramlasLayout chrome so boot skeleton aligns with /aramlas/home content. */
export function AramlasHomeShellLoadingFrame({
  children,
  className,
}: AramlasHomeShellLoadingFrameProps) {
  return (
    <div
      data-testid="aramlas-home-shell-loading-frame"
      className={cn(
        "min-h-screen w-full relative p-2 md:p-4 antialiased [overflow-x:clip] lg:pt-0 bg-white",
        className,
      )}
    >
      <div
        className={cn(
          "flex min-h-screen transition-all duration-200",
          UNIFIED_NAVBAR_CONTENT_OFFSET_CLASS,
        )}
      >
        <div
          className={cn(
            "flex-1 w-full max-w-full transition-all duration-300",
            !PUBLIC_SHELL_HIDE_HOME_SIDEBAR && "lg:pl-24",
          )}
        >
          <main
            className={cn(
              "mx-auto flex flex-col justify-start min-w-0 w-full max-w-full",
              "pb-[calc(6.5rem+env(safe-area-inset-bottom,0px))] md:pb-32",
            )}
          >
            <div className="flex-1 [overflow-x:clip] lg:overflow-x-visible min-h-0">
              <div className="w-full relative flex flex-col">{children}</div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}
